import React from 'react';
import { components } from 'react-select';

const CustomMultiValueContainer = props => (
  <div className={props.selectProps.multiContainerClassname}>
    <components.MultiValueContainer {...props}>{props.children}</components.MultiValueContainer>
  </div>
  );
export default CustomMultiValueContainer;
